export const layoutHistoryActionTypes = {
  changeLayoutType: 'changeLayoutType',
  changeLayout: 'changeLayout',
}
